module.exports = __webpack_public_path__ + "img/Generic.7cde6e1a.png";